import React, { useEffect, useState } from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAPI } from 'store/apiReducer';
import SimpleTable from 'components/Commun/Table/SimpleTable';
import usagerClientReducer from '../../store/usagerReducer';
import {
    API_GET_REFERENTIEL_PAYS,
    CONTEXT_GET_REFERENTIEL_PAYS,
} from '../../constants/apiUrls.constants';
import BoutonTelechargementFichier from '../BoutonTelechargementFichier/BoutonTelechargementFichier';

const TableAdressesComponent = ({
    referentielPays,
    getApi,
    listeAdresses,
    listeId,
    actions,
    labelTableau,
    isLoading,
}) => {
    const [donneesTable, setDonneesTable] = useState([]);
    const titresTable = [labelTableau, ''];

    const getPays = () => {
        getApi(usagerClientReducer, API_GET_REFERENTIEL_PAYS, CONTEXT_GET_REFERENTIEL_PAYS);
    };

    useEffect(() => {
        if (isLoading === null && (!referentielPays || Object.keys(referentielPays).length === 0)) {
            getPays();
        }
    });

    const getLibellePays = (id) => {
        if (referentielPays) {
            for (let i = 0; i < referentielPays.length; i += 1) {
                if (referentielPays[i].id.toString() === id.toString()) {
                    return referentielPays[i].libelle;
                }
            }
        }
        return 'Pays inconnu';
    };

    const convertAdressePourAfficher = (data) => {
        if (data.nationalite) {
            return `${data.adresseInternationale}, ${getLibellePays(data.pays)}`;
        }
        return (
            <>
                {data.numeroDeVoie} {data.extension} {data.typeEtNomDeVoie} {data.lieuDit},{' '}
                {data.codePostal} {data.ville}, FRANCE
                <br />
                {data.justificatifsDomicile &&
                    data.justificatifsDomicile.fichiers.length > 0 &&
                    data.justificatifsDomicile.fichiers.map((justificatif) => {
                        return (
                            <BoutonTelechargementFichier
                                libelle={justificatif.filename}
                                uuidFichier={justificatif.uuid}
                                key={justificatif.uuid}
                                aria-label="Télécharger le justicatif de domicile"
                            />
                        );
                    })}
            </>
        );
    };

    useEffect(() => {
        const nouvelleTable = [];
        let actionId = 0;
        for (let i = 0; i < listeAdresses.length; i += 1) {
            if (listeId) {
                actionId = listeId[i];
            } else {
                actionId = i;
            }
            nouvelleTable.push([convertAdressePourAfficher(listeAdresses[i]), actions(actionId)]);
        }
        setDonneesTable(nouvelleTable);
    }, [listeAdresses]);

    const displayTable = () => {
        if (donneesTable[0]) {
            return (
                <SimpleTable
                    isLoading={isLoading}
                    entete={titresTable}
                    donnees={donneesTable}
                    boutonActionsPresent
                />
            );
        }
        return <></>;
    };

    return displayTable();
};

TableAdressesComponent.propTypes = {
    isLoading: PropTypes.bool,
    listeAdresses: PropTypes.shape.isRequired,
    listeId: PropTypes.shape.isRequired,
    actions: PropTypes.func.isRequired,
    labelTableau: PropTypes.string,
    referentielPays: PropTypes.object.isRequired,
};

TableAdressesComponent.defaultProps = {
    isLoading: false,
    labelTableau: 'Adresse(s)',
};

export default connect(
    (state) => {
        const { isLoading, erreur, data, message } = state.referentiel.pays;
        return {
            isLoading,
            erreur,
            referentielPays: data,
            message,
        };
    },
    {
        getApi: getAPI,
    },
)(TableAdressesComponent);
